@optional @link fn getWhitePoint() -> f32 { return 4.0; }

const A = 0.15;
const B = 0.50;
const C = 0.10;
const D = 0.20;
const E = 0.02;
const F = 0.30;

// Hable 2010, "Filmic Tonemapping Operators"
@export fn tonemapHable(color: vec4<f32>) -> vec4<f32> {
  let wp = getWhitePoint();
  let rgb = color.rgb;

  return vec4<f32>(hable3(rgb * 2.0) / hable(wp), color.a);
};

fn hable(x: f32) -> f32 {
  return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;
};

fn hable3(x: vec3<f32>) -> vec3<f32> {
  return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;
};
